import React, {Component} from 'react'
import {Button, DatePicker, Form, Input, Select, Upload, Spin} from 'antd'
import moment from 'moment'
import {api, app, config} from '../../app'
import common from '../report/common'
import {insuraNameSelectLists, insuranceEidt, insuranceUpload, insuraTypeSelectLists} from './insure_api'

const FormItem = Form.Item
const Option = Select.Option

class IUpload extends Component {
    constructor(props) {
        super(props)
        this.state = {
            companyList: [],
            company_loading: true,
            typeList: [],
            type_loading: true
        }
    }

    async componentDidMount() {
        this._isMounted = true
        await this.setData({companyList: await insuraNameSelectLists(), company_loading: false})
        await this.setData({typeList: await insuraTypeSelectLists(), type_loading: false})
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 提交
     * @param e
     */
    handleSubmit = (e) => {
        e.preventDefault()
        this.props.form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                let urls = []
                for (let i = 0; i < values.img.length; i++) {
                    if (values.img[i].status === 'uploading') {
                        app.alert(`第${i + 1}张图片正在上传！`, 'warn', '45%')
                        return
                    }
                    if (values.img[i].status === 'done' && values.img[i].response && values.img[i].response.flag === 1) {
                        urls.push(values.img[i].response.data.url)
                    }
                }
                if (!urls.length || urls.length > 5) {
                    app.alert(`请上传1~5张保单图片！`, 'warn', '45%')
                    return
                }
                await this.setData({submit_loading: true})
                const params = {...values}
                params.img = urls.join(':::')
                params.start_date = values.date[0].format('YYYY-MM-DD')
                params.end_date = values.date[1].format('YYYY-MM-DD')
                delete params.date
                const {info} = this.props
                let flag = false
                if (info && info.id) {
                    params.id = info.id
                    flag = await insuranceEidt(params)
                } else {
                    flag = await insuranceUpload(params)
                }
                flag && await this.props.onCancel()
                await this.setData({submit_loading: false})
            }
        })
    }

    render() {
        let {getFieldDecorator, getFieldsValue} = this.props.form,
            info = {...this.props.info},
            formItemLayout = {
                labelCol: {span: 6},
                wrapperCol: {span: 14},
            },
            formData = getFieldsValue(),
            {submit_loading, companyList, company_loading, typeList, type_loading} = this.state
        return (
            <div className="insure-upload-page">
                <Form {...formItemLayout} onSubmit={this.handleSubmit}>
                    <FormItem label="保险图片" onSubmit={this.handleSubmit}>
                        {getFieldDecorator('img', {
                            rules: [
                                {type: 'array', required: true, message: '请上传保单图片！'},
                            ],
                            valuePropName: 'fileList',
                            getValueFromEvent: e => {
                                if (Array.isArray(e)) {
                                    return e
                                }
                                return e && e.fileList
                            },
                            initialValue: info.img instanceof Array && info.img.length ? info.img.map((img, i) => {
                                let xh = i + 1
                                return {
                                    uid: 'baodan-' + xh,      // 文件唯一标识，建议设置为负数，防止和内部产生的 id 冲突
                                    name: '保单' + xh + img.substr(img.lastIndexOf('.')),   // 文件名
                                    status: 'done', // 状态有：uploading done error removed
                                    response: {flag: 1, data: {url: img}}, // 服务端响应内容
                                    url: config.imgUrl + img,
                                    thumbUrl: config.imgUrl + img,
                                }
                            }) : null
                        })(
                            <Upload
                                accept='image/jpeg, image/jpg, image/png'
                                action={config.serverUrl + api.ImageUpload}
                                listType="picture"
                                beforeUpload={common.beforeUpload}
                                data={{
                                    token: app.getData('token'),
                                    indexno: app.getData('indexno'),
                                    account: app.getData('account'),
                                    upload_type: 'taskInsure'
                                }}
                                name="image"
                            >
                                {
                                    !formData.img || formData.img && formData.img.length < 5 ? (
                                        <Button size="small" type="primary">上传图片</Button>
                                    ) : null
                                }
                            </Upload>
                        )}
                    </FormItem>
                    <FormItem label="保险名称">
                        {getFieldDecorator('name', {
                            rules: [{required: true, message: '请填写保险名称！'}],
                            initialValue: info.name ? info.name : null
                        })(
                            <Input placeholder="请填写"/>
                        )}
                    </FormItem>
                    <FormItem label="保险单号">
                        {getFieldDecorator('cntr_no', {
                            rules: [{required: true, message: '请填写保险单号！'}],
                            initialValue: info.cntr_no ? info.cntr_no : null
                        })(
                            <Input placeholder="请填写"/>
                        )}
                    </FormItem>
                    <FormItem label="承保公司">
                        {getFieldDecorator('company', {
                            rules: [{required: true, message: '请填写承保公司！'}],
                            initialValue: info.company ? info.company : undefined
                        })(
                            <Select placeholder="请选择" showSearch
                                    notFoundContent={company_loading ? (<Spin size="small"/>) : null}>
                                {
                                    companyList.map(c => (
                                        <Option key={c.value}>{c.name}</Option>
                                    ))
                                }
                            </Select>
                        )}
                    </FormItem>
                    <FormItem label="保险类型">
                        {getFieldDecorator('type', {
                            rules: [{required: true, message: '请填写保险类型！'}],
                            initialValue: info.type ? info.type : undefined
                        })(
                            <Select placeholder="请选择" style={{width: '100%'}} disabled={info.type}
                                    notFoundContent={type_loading ? (<Spin size="small"/>) : null}>
                                {
                                    typeList.map(c => (
                                        <Option key={c.value}>{c.name}</Option>
                                    ))
                                }
                            </Select>
                        )}
                    </FormItem>
                    <FormItem label="保险有效期">
                        {getFieldDecorator('date', {
                            rules: [{required: true, message: '请选择保险有限期！'}],
                            initialValue: info.start_date && info.end_date ? [moment(info.start_date), moment(info.end_date)] : undefined
                        })(
                            <DatePicker.RangePicker format="YYYY年MM月DD日" style={{width: '100%'}}/>
                        )}
                    </FormItem>
                    <FormItem label="投保人">
                        {getFieldDecorator('hldr_name', {
                            rules: [{required: true, message: '请填写投保人！'}],
                            initialValue: info.hldr_name ? info.hldr_name : null
                        })(
                            <Input placeholder="请填写"/>
                        )}
                    </FormItem>
                    <FormItem label="被保人">
                        {getFieldDecorator('ipsn_name', {
                            rules: [{required: true, message: '请填写被保人！'}],
                            initialValue: info.ipsn_name ? info.ipsn_name : null
                        })(
                            <Input placeholder="请填写"/>
                        )}
                    </FormItem>
                    <FormItem wrapperCol={{offset: 6, span: 14}}>
                        <Button type="primary" loading={submit_loading} htmlType="submit" block>提交审核</Button>
                    </FormItem>
                    <div style={{color: 'red', textAlign: 'center'}}>
                        注：确保上传保单真实有效且界面清晰，每张图片不可大于3M，最多上传5张。<br/>{info && info.id ? '保单信息修改后需要重新审核。' : ''}</div>
                </Form>
            </div>
        )
    }
}

export default Form.create()(IUpload)



// WEBPACK FOOTER //
// ./src/routes/insure/IUpload.jsx